import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import SectionLibrary from './SectionLibrary/SectionLibrary';

export default function SectionLibraryWrapper() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Header Section */}
      <Box sx={{ 
        bgcolor: 'primary.main', 
        color: 'white', 
        py: 4,
        position: 'relative',
        overflow: 'hidden'
      }}>
        <Container maxWidth="lg">
          <Typography variant="h3" fontWeight={700} gutterBottom>
            Section Library
          </Typography>
          <Typography variant="h6" color="primary.light">
            Comprehensive steel section database with Australian Standards compliance
          </Typography>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          <SectionLibrary />
        </Paper>
      </Container>
    </Box>
  );
}


